import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Cookies from "js-cookie";
import { useForm, Controller } from "react-hook-form";
import { countryCode, CountryList } from "../../apis/api/CountryList";
import { MemberUpdate } from "../../apis/api/MemberApi";
import Lodderr from "../../components/Lodder/Lodder";
import { toast } from "react-toastify";
import { GetMembers } from "../../apis/api/MemberApi";
import cookies from "js-cookie";

const EditDetailsofMember = ({ show, onHide, data, company_id,userId}) => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);
 
  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const countryCodeData = useSelector((state) => state.countrySlice);
  const countryCodeOptions = countryCodeData?.countryCode?.data?.data || [];
  const { loading } = useSelector((state) => state.MemberSlice);
  const { country } = useSelector((state) => state.countrySlice);

  const titleOptions = ["Mr", "Mrs", "Ms"].map((t) => ({ label: t, value: t }));

  const handleCloseModal = () => {
    reset();
    setPreview(null);
    onHide();
  };

  useEffect(() => {
    dispatch(countryCode());
    dispatch(CountryList());
  }, [dispatch]);

  useEffect(() => {
    if (data && country?.length && countryCodeOptions?.length) {
      const selectedCountry = country.find(
        (c) => c.label?.trim() === data?.country?.trim()
      );

      const selectedCode = countryCodeOptions.find(
        (code) =>
          code.label?.trim().endsWith(" " + data.country_code) ||
          code.value?.trim().endsWith(" " + data.country_code)
      );

      reset({
        Title: data.salutation
          ? { label: data.salutation, value: data.salutation }
          : null,
        FirstName: data.first_name || "",
        MemberId: data.id || "",
        MiddleName: data.middle_name || "",
        LastName: data.last_name || "",
        JobTitle: data.job_title || "",
        Department: data.department || "",
        PhoneDirect: data.contact || "",
        Email: data.email || "",
        Country: selectedCountry || null,
        CountryCode: selectedCode || null,
        Access: data.member_Access?.toString() || "0",
      });

      setPreview(
        typeof data.member_logo === "string"
          ? data.member_logo
          : data.member_logo instanceof File
          ? URL.createObjectURL(data.member_logo)
          : null
      );
    }
  }, [data, reset, country, countryCodeOptions]);

  const onSubmit = async (formData) => {
    const form = new FormData();
    const mappedFields = {
      Title: formData.Title?.value || "",
      FirstName: formData.FirstName,
      MiddleName: formData.MiddleName,
      LastName: formData.LastName,
      JobTitle: formData.JobTitle,
      Department: formData.Department,
      PhoneDirect: formData.PhoneDirect,
      Email: formData.Email,
      Country: formData.Country?.label || "",
      CountryCode: formData.CountryCode?.value || "",
      Access: formData.Access,
      MemberId: formData.MemberId,
    };

    for (let key in mappedFields) {
      if (mappedFields[key] !== undefined && mappedFields[key] !== null) {
        form.append(key, mappedFields[key]);
      }
    }

    if (formData.ProfilePicture instanceof File) {
      form.append("ProfilePicture", formData.ProfilePicture);
    }

    console.log([...form.entries()], "Payload for Submission");

    const response = await dispatch(MemberUpdate(form));
    if (response.payload.status == "success") {
        await dispatch(GetMembers({ company_id, userId }));
      toast.success("Member updated successfully.");
    } else {
      toast.success("error in form submission.");
    }
    handleCloseModal();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      setValue("ProfilePicture", file, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <>
      {loading && <Lodderr />}
      <Modal show={show} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-semibold text-dark">
            Update Member
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light px-4 py-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4">
              {/* Profile Picture */}
              <div className="col-md-12">
                <label className="form-label fw-bold">Profile Picture</label>
                <div
                  className="d-flex flex-column align-items-center justify-content-center border border-2 border-dashed rounded-3 p-4 bg-white"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    document.getElementById("member-logo-upload").click()
                  }
                >
                  <input
                    type="file"
                    id="member-logo-upload"
                    accept="image/*"
                    className="d-none"
                    onChange={handleFileChange}
                  />
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      className="rounded-circle shadow"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <>
                      <i className="fas fa-upload fs-2 text-muted mb-2"></i>
                      <span className="text-muted">
                        Click or drag file to upload
                      </span>
                    </>
                  )}
                </div>
              </div>

              {/* Title */}
              <div className="col-md-12">
                <label className="form-label fw-bold">Title</label>
                <Controller
                  name="Title"
                  control={control}
                  rules={{ required: "Title is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={titleOptions}
                      placeholder="Select Title"
                    />
                  )}
                />
                {errors.Title && (
                  <p className="text-danger">{errors.Title.message}</p>
                )}
              </div>

              {/* Name Fields */}
              {["FirstName", "MiddleName", "LastName"].map((field) => (
                <div className="col-md-4" key={field}>
                  <label className="form-label fw-bold">
                    {field.replace("Name", " Name")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={
                      field === "FirstName"
                        ? "John"
                        : field === "MiddleName"
                        ? "M."
                        : "Doe"
                    }
                    {...register(field, {
                      required:
                        field !== "MiddleName"
                          ? `${field.replace("Name", " name")} is required`
                          : false,
                    })}
                  />
                  {errors[field] && (
                    <p className="text-danger">{errors[field].message}</p>
                  )}
                </div>
              ))}

              {/* Job Title */}
              <div className="col-md-6">
                <label className="form-label fw-bold">Job Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter job title"
                  {...register("JobTitle", {
                    required: "Job title is required",
                  })}
                />
                {errors.JobTitle && (
                  <p className="text-danger">{errors.JobTitle.message}</p>
                )}
              </div>

              {/* Department */}
              <div className="col-md-6">
                <label className="form-label fw-bold">Department</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter department"
                  {...register("Department", {
                    required: "Department is required",
                  })}
                />
                {errors.Department && (
                  <p className="text-danger">{errors.Department.message}</p>
                )}
              </div>

              {/* Phone Number with Country Code */}
              <div className="col-md-12">
                <label className="form-label fw-bold">Phone Number</label>
                <div className="d-flex gap-2">
                  <Controller
                    name="CountryCode"
                    control={control}
                    rules={{ required: "Country code is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        className="w-25"
                        options={countryCodeOptions}
                        placeholder="Code"
                      />
                    )}
                  />
                  <input
                    type="text"
                    className="form-control w-75"
                    {...register("PhoneDirect", {
                      required: "Phone number is required",
                    })}
                  />
                </div>
                {errors.CountryCode && (
                  <p className="text-danger">{errors.CountryCode.message}</p>
                )}
                {errors.PhoneDirect && (
                  <p className="text-danger">{errors.PhoneDirect.message}</p>
                )}
              </div>

              {/* Country Dropdown */}
              <div className="col-md-12">
                <label className="form-label fw-bold">Country</label>
                <Controller
                  name="Country"
                  control={control}
                  rules={{ required: "Country is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={country}
                      placeholder="Select Country"
                    />
                  )}
                />
                {errors.Country && (
                  <p className="text-danger">{errors.Country.message}</p>
                )}
              </div>

              {/* Access */}
              <div className="col-md-12">
                <label className="form-label fw-bold">Access</label>
                <Controller
                  name="Access"
                  control={control}
                  rules={{ required: "Access type is required" }}
                  render={({ field }) => (
                    <>
                      <div className="form-check form-check-inline ms-3">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="admin"
                          value="0"
                          checked={field.value === "0"}
                          onChange={field.onChange}
                        />
                        <label className="form-check-label" htmlFor="admin">
                          Admin
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="member"
                          value="1"
                          checked={field.value === "1"}
                          onChange={field.onChange}
                        />
                        <label className="form-check-label" htmlFor="member">
                          Member
                        </label>
                      </div>
                    </>
                  )}
                />
                {errors.Access && (
                  <p className="text-danger">{errors.Access.message}</p>
                )}
              </div>

              <input type="text" name="MemberId" hidden />

              {/* Submit Button */}
              <div className="col-12 text-end">
                <button
                  type="submit"
                  className="btn btn-secondary px-4 shadow-sm"
                >
                  Update Member
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditDetailsofMember;
